
import Events from "./classes/events";
import NewsContainer from "./classes/news-container";

// global window defines
declare global {
    interface Window {
        // add any new globals here
        news: NewsContainer;
        events: Events;
     }
}

const newsEventsInit = function () {
    // make sure lay load loads before this file
    window.events = new Events();
    window.news = new NewsContainer();
}
newsEventsInit();